// extracted by mini-css-extract-plugin
module.exports = {"container":"CommunityTagsFilter_container__zUy-X","deleteIcon":"CommunityTagsFilter_deleteIcon__3zY3U"};